// extracted by mini-css-extract-plugin
module.exports = {"verseLink":"VerseLink_verseLink__m_uNh"};